import { getChainDefinition } from '../schema/mapping';

import { getChainRolePath } from './roleChainRelationships';

export interface ChainRoleAssignment {
  boneIndex: number;
  roleName: string;
}

function getFallbackIterativeAssignments(
  chainName: string,
  boneCount: number,
): ChainRoleAssignment[] {
  const maxRoles = Math.min(boneCount, 3);
  const iterativeSeparator = /_\d+$/.test(chainName) ? '_' : '';

  return Array.from({ length: maxRoles }, (_, index) => ({
    boneIndex: index,
    roleName: `${chainName}${iterativeSeparator}${index + 1}`,
  }));
}

export function getChainRoleAssignments(
  chainName: string,
  boneCount: number,
): ChainRoleAssignment[] {
  if (boneCount <= 0) return [];

  const chainDefinition = getChainDefinition(chainName);
  if (!chainDefinition) {
    return getFallbackIterativeAssignments(chainName, boneCount);
  }

  const chainRolePath = getChainRolePath(chainName);
  if (chainRolePath && boneCount === chainRolePath.rolePath.length) {
    return chainRolePath.rolePath.map((roleName, boneIndex) => ({
      boneIndex,
      roleName,
    }));
  }

  const assignments: ChainRoleAssignment[] = [
    {
      boneIndex: 0,
      roleName: chainDefinition.startRole,
    },
  ];

  if (boneCount > 1 && chainDefinition.endRole !== chainDefinition.startRole) {
    assignments.push({
      boneIndex: boneCount - 1,
      roleName: chainDefinition.endRole,
    });
  }

  return assignments;
}
